import { render } from "./About.vue?vue&type=template&id=d5efd318&scoped=true&ts=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=d5efd318&scoped=true&lang=scss"

import exportComponent from "/Users/leonardomarsigli/code/LeoMarseo/personal-projects/dirtysocks-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5efd318"]])

export default __exports__